const cleanString = (str?: string): string =>
  str
    ?.trim()
    .replace(/[^a-zA-Z0-9]+/g, "-")
    .toLowerCase() || "";

const getLocationsForJD = (job: any): string | undefined => {
  if (typeof job?.locations === "string") return job?.locations.split(",")[0];

  return (
    job?.locations?.find((location: any) => location.city || location.country)
      ?.city ||
    job?.locations?.find((location: any) => location.city || location.country)
      ?.country
  );
};

export const generateJDUrl = (
  job: any,
  searchParams?: URLSearchParams,
): string => {
  if (!job) return "";

  const jobTitleUrl = cleanString(job?.title);
  const companyNameForUrl = job?.hideCompanyName
    ? ""
    : cleanString(job?.companyName);
  const locationForUrl = cleanString(getLocationsForJD(job));

  const isSJSJob = job?.jobTypes?.some(
    (type: string) => type.toLowerCase() === "sjs",
  );
  const isHTMLExtRequired = !isSJSJob && job?.isCJT;

  let finalUrl = `${jobTitleUrl}-${companyNameForUrl}-${locationForUrl}-${job?.id}`;
  finalUrl = cleanString(finalUrl);

  if (isSJSJob) {
    finalUrl = `/seeker/sjs/${finalUrl}`;
  } else if (isHTMLExtRequired) {
    const experience = `${job?.minimumExperience?.years}-${job?.maximumExperience?.years}-years`;
    finalUrl = `job-vacancy-${jobTitleUrl}-${companyNameForUrl}-${locationForUrl}-${experience}-${job?.kiwiJobId}`;
    finalUrl = cleanString(finalUrl);
    finalUrl = `/seeker/cjt/${finalUrl}`;
  } else {
    finalUrl = `/job/${finalUrl}`;
  }

  if (searchParams?.has("spl")) {
    finalUrl += `?spl=${searchParams.getAll("spl").join(",")}`;
  }

  return finalUrl;
};
